import ReactECharts from "echarts-for-react";
import debounce from "lodash/debounce";
import { useEffect, useRef, useState } from "react";

type EchartProps = {
  option: Record<string, unknown>;
  trigger?: number;
  heightWithCustomUnit?: boolean;
  height: number | string;
  width?: string;
};

const Echart = ({
  option,
  trigger,
  height,
  heightWithCustomUnit,
  width,
}: EchartProps) => {
  "use no memo";
  const ref = useRef<ReactECharts>(null);
  const [canDisplay, setCanDisplay] = useState(false);

  const handleResize = debounce(() => {
    if (!ref.current) return;
    ref.current.getEchartsInstance()?.resize();
  }, 100);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setCanDisplay(true);
      handleResize();
    }, 100);

    // Attach and detach resize listener
    window.addEventListener("resize", handleResize);
    return () => {
      clearTimeout(timeout);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    option && (
      <ReactECharts
        ref={ref}
        option={option}
        notMerge={true}
        lazyUpdate={true}
        key={trigger || 0}
        opts={{ renderer: "svg" }}
        style={{
          opacity: canDisplay ? 1 : 0,
          height: heightWithCustomUnit ? height : `${height}px`,
          width: width ? `${width}%` : "100%", // Simplified width logic
        }}
      />
    )
  );
};

export default Echart;
